import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { cleanupExpiredProcessMiningStates } from '../reducers/processMiningReducer';

const useProcessMiningCleanup = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(cleanupExpiredProcessMiningStates());

    // Periodic cleanup every 1 minute
    const interval = setInterval(() => {
      dispatch(cleanupExpiredProcessMiningStates());
    }, 1 * 60 * 1000);

    return () => clearInterval(interval);
  }, [dispatch]);
};

export default useProcessMiningCleanup;
